type Plan = {
  name: string
  description: string
  price: string
  features: Array<string>
  buttonName: string
}

export const pricingPlans: Plan[] = [
  {
    name: "Standard",
    description: "Fast slicing and the essentials for your everyday resin printing workflow.",
    price: '3', // Contact for quote
    features: [
      "Very fast slicing",
      "Manual object placement on the build plate",
      "STL model import",
      "CTB export for compatible printers",
    ],
    buttonName: "Available soon"
  },
  {
    name: "Enterprise",
    description: "We're open to ideas and partnerships with companies that need fast, easy-to-use slicing software. We'd love to develop Slick with you and adapt it to your needs.",
    price: '', // Contact for quote
    features: [
      "Let's explore your ideas for developing Slick together",
      "Shape new features around your company's needs",
      "Work with our team to adapt Slick to your workflow",
    ],
    buttonName: "Available soon"
  }
];
